module.exports = __webpack_public_path__ + "img/375_booking_arrow.2cac5db6.svg";